import React, { useState } from 'react';
import { WORKER_URL, getAuthHeaders } from '../../utils/api';

export default function TermsModal({ onAccepted }) {
  const [loading, setLoading] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const handleScroll = (e) => {
    const el = e.target;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 20) setScrolled(true);
  };

  const handleAccept = async () => {
    setLoading(true);
    try {
      await fetch(`${WORKER_URL}/api/user/accept-terms`, {
        method: 'POST',
        headers: getAuthHeaders(),
      });
      onAccepted();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div style={{ backgroundColor: 'white', borderRadius: '12px', width: '100%', maxWidth: '620px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>

        {/* Header */}
        <div style={{ padding: '24px 28px 16px', borderBottom: '1px solid #eee' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '4px' }}>
            <div style={{ width: '40px', height: '40px', backgroundColor: '#2D3277', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ color: 'white', fontWeight: 800, fontSize: '16px' }}>IM</span>
            </div>
            <div>
              <h2 style={{ margin: 0, color: '#2D3277', fontSize: '1.1rem', fontWeight: 700 }}>Termos de Uso — Integra MKP</h2>
              <p style={{ margin: 0, color: '#999', fontSize: '0.75rem' }}>Leia com atenção antes de continuar</p>
            </div>
          </div>
        </div>

        {/* Scroll area */}
        <div onScroll={handleScroll} style={{ overflowY: 'auto', padding: '24px 28px', flex: 1, fontSize: '0.85rem', lineHeight: '1.7', color: '#333' }}>

          <Section title="1. DAS PARTES E DO OBJETO">
            O presente contrato regula o uso da plataforma <strong>Integra MKP</strong> ("Plataforma"), serviço de gestão e integração de dados para vendedores do Mercado Livre, mediante aceite eletrônico pelo usuário ("Contratante"). Ao clicar em "Li e aceito os termos", o Contratante declara ter lido, compreendido e concordado integralmente com as condições aqui estabelecidas.
          </Section>

          <Section title="2. PRAZO DO CONTRATO">
            O contrato é mensal, sem fidelidade. O Contratante pode cancelar a qualquer momento, sem multa ou aviso prévio.
          </Section>

          <Section title="3. PAGAMENTO E COBRANÇA">
            O valor da mensalidade é de <strong>R$ 40,00 (quarenta reais)</strong>, com vencimento 30 dias após a aceitação destes termos e subsequentemente a cada 30 dias.
            <br /><br />
            Após o vencimento, o Contratante dispõe de <strong>7 (sete) dias corridos de carência</strong> para efetuar o pagamento sem interrupção do serviço. A partir do 3º dia de atraso, um aviso de inadimplência será exibido no aplicativo com contagem regressiva. O não pagamento dentro do prazo de carência resultará no <strong>bloqueio imediato e total do acesso</strong> à Plataforma, sem necessidade de notificação prévia adicional.
            <br /><br />
            O desbloqueio ocorre automaticamente após a confirmação do pagamento.
          </Section>

          <Section title="4. VINCULAÇÃO AO MERCADO LIVRE">
            O acesso à Plataforma é vinculado ao <strong>ID de conta do Mercado Livre</strong> do Contratante. Em caso de inadimplência, o bloqueio se aplica ao ID do Mercado Livre registrado, independentemente do email ou conta SaaS utilizada. A criação de nova conta com outro email não elimina débitos pendentes associados ao mesmo ID do Mercado Livre.
          </Section>

          <Section title="5. DADOS E INTEGRAÇÕES — LIMITAÇÃO DE RESPONSABILIDADE">
            A Plataforma exibe dados obtidos via <strong>API oficial do Mercado Livre</strong>. Esses dados podem apresentar <strong>atrasos, inconsistências, arredondamentos ou divergências</strong> em relação ao site oficial do Mercado Livre, decorrentes de limitações técnicas, atualizações de API, instabilidades de terceiros ou outros fatores fora do controle da Integra MKP.
            <br /><br />
            <strong>Em caso de dúvida sobre qualquer informação exibida — incluindo valores de vendas, status de pedidos, métricas de reputação ou dados financeiros — o Contratante deve consultar diretamente o site ou aplicativo oficial do Mercado Livre.</strong>
            <br /><br />
            A Integra MKP <strong>não se responsabiliza por decisões comerciais, financeiras ou operacionais</strong> tomadas com base exclusivamente nos dados exibidos na Plataforma.
          </Section>

          <Section title="6. DISPONIBILIDADE DO SERVIÇO">
            A Plataforma está sujeita a interrupções decorrentes de manutenção programada, falhas de infraestrutura de terceiros (Mercado Livre, Cloudflare, Brevo), atualizações de sistema ou casos de força maior. A Integra MKP <strong>não garante disponibilidade ininterrupta</strong> e não é responsável por prejuízos decorrentes de indisponibilidade temporária do serviço.
          </Section>

          <Section title="7. RESPONSABILIDADES DO CONTRATANTE">
            O Contratante é responsável por: (a) manter a confidencialidade de suas credenciais de acesso; (b) usar a Plataforma em conformidade com a legislação brasileira vigente; (c) respeitar os Termos de Uso do Mercado Livre; (d) não utilizar a Plataforma para fins ilícitos, fraudulentos ou que violem direitos de terceiros.
          </Section>

          <Section title="8. CANCELAMENTO E RESCISÃO">
            O cancelamento pode ser solicitado a qualquer momento, sem multa. Valores já pagos não são reembolsados. O acesso permanece ativo até o fim do período pago.
            <br /><br />
            A Integra MKP reserva-se o direito de rescindir o contrato, sem aviso prévio, em caso de uso indevido da Plataforma, fraude ou violação dos presentes termos.
          </Section>

          <Section title="9. PRIVACIDADE E PROTEÇÃO DE DADOS">
            Os dados do Contratante são armazenados de forma segura em servidores da Cloudflare e não são compartilhados com terceiros, exceto quando estritamente necessário para a prestação do serviço (ex: integração com API do Mercado Livre). A Integra MKP adota práticas compatíveis com a <strong>Lei Geral de Proteção de Dados (LGPD — Lei nº 13.709/2018)</strong>.
          </Section>

          <Section title="10. ALTERAÇÕES DOS TERMOS">
            A Integra MKP poderá atualizar estes Termos a qualquer momento. O Contratante será notificado por email e deverá aceitar os novos termos para continuar utilizando a Plataforma. O uso continuado após a notificação implica aceitação das alterações.
          </Section>

          <Section title="11. FORO">
            As partes elegem o foro da Comarca de São Paulo — SP para dirimir quaisquer controvérsias decorrentes deste contrato, com renúncia a qualquer outro, por mais privilegiado que seja.
          </Section>

          <p style={{ color: '#aaa', fontSize: '0.75rem', marginTop: '24px', textAlign: 'center' }}>
            Ao aceitar, você confirma que leu e concorda com todos os termos acima.<br />
            Data de aceite será registrada: {new Date().toLocaleDateString('pt-BR')}
          </p>
        </div>

        {/* Footer */}
        <div style={{ padding: '16px 28px 24px', borderTop: '1px solid #eee' }}>
          {!scrolled && (
            <p style={{ textAlign: 'center', color: '#aaa', fontSize: '0.78rem', marginBottom: '12px' }}>
              Role até o final para habilitar o botão de aceite
            </p>
          )}
          <button
            onClick={handleAccept}
            disabled={!scrolled || loading}
            style={{
              width: '100%', padding: '13px', backgroundColor: scrolled ? '#2D3277' : '#ccc',
              color: 'white', border: 'none', borderRadius: '8px', fontSize: '0.95rem',
              fontWeight: 600, cursor: scrolled && !loading ? 'pointer' : 'not-allowed',
              transition: 'background 0.3s',
            }}
          >
            {loading ? 'Aguarde...' : 'Li e aceito os termos de uso'}
          </button>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '20px' }}>
      <h3 style={{ color: '#2D3277', fontSize: '0.85rem', fontWeight: 700, marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{title}</h3>
      <p style={{ margin: 0, color: '#444' }}>{children}</p>
    </div>
  );
}
